var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageNon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 546.975,
    height: 139.428,
    preserveAspectRatio: "none",
    viewBox: "0 0 546.975 139.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33296",
    "data-name": "Group 33296",
    transform: "translate(-571.861 -87.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    d: "M517.952,0H26.042C11.656,0-.006,8.408-.006,18.779v93.9L-1.14,136.319C5.539,118.5,29.448,83.643,67.118,80.176s324.267-1.445,385.713,0c15.361.482,82.984-1.21,93-39.491l-.7-22.364C544.035,7.957,532.337,0,517.952,0Z",
    transform: "translate(573.002 91)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    d: "M492.047,0H-.053C-15.03-1-24,8.179-26.388,18.651l-.612,6.8v108.4c6.655-17.656,30.341-53.825,67.872-57.261s325.073-1.432,386.294,0c15.3.477,82.6,3.241,92.578-34.695l-.126-16.274V21.249l-.644-2.751C515.775,6.511,505.044-1.123,492.047,0Z",
    transform: "translate(599.002 88)",
    fill: "#e3e3e3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageNon);
export default __webpack_public_path__ + "static/media/average_non.6080f0949056a7517be2968892be30a6.svg";
export { ForwardRef as ReactComponent };